module.exports = __webpack_public_path__ + "static/media/oracle.d60e7424.svg";